module.exports = __webpack_public_path__ + "img/T2A_rc_3.14cb7576.png";